// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover_cover__2A3Sz","mac":"cover_mac__1l2LJ","heading1":"cover_heading1__3631j","btn":"cover_btn__1v9rm"};